import {DefaultVideoListModel} from "./default-video-list.model";
import {STATIC_VIDEO_ITEM} from "../../../../../themes/css-global-classes";
import {SwiperGamesListConfiguration} from "../../../../configurations/config-data-sections/arenas.configuration";
import {IArenaToGamesListAdapter} from "../../arenas/arena-to-games-list-adapter.interface";

export class StaticVideoListModel extends DefaultVideoListModel {

    constructor(listConfiguration: SwiperGamesListConfiguration, arena: IArenaToGamesListAdapter) {
        super(listConfiguration, arena);

        this.services.staticVideoPlaying.setSwiperHandler(this.swipeLogicHandler);
    }

    get templateType(): string {
        return STATIC_VIDEO_ITEM;
    }

    private _isStaticVideoListDisabled = () => {
        return (
            this.services.miniOrbit.isEnabled ||
            this.services.staticVideoPlaying.isDisabledPrelogin ||
            !this.services.abTestingFeatureDataProvider.isStaticVideoListEnabled
        );
    };

    protected _shouldBeDisplayed(): boolean {
        if(this._isStaticVideoListDisabled()) {
            return false;
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    get maxGamesToShowInList(): number {
        return 4;
    }

    protected _getGameTypes(): number[] {

        let baseArray = [...this.listConfiguration.gamesId];
        let gameTypes = this._cycleGamesAndIncrementOffset(baseArray);

        gameTypes = gameTypes.filter((gt) => this.services.games.gamesMap[gt]?.hasVideoURL);

        return gameTypes;
    }

    get numberOfGamesSkeletons(): number {
        return this._getNumberOfGamesSkeletons();
    }

    protected _getNumberOfGamesSkeletons(): number {
        return 1;
    }
}
